import React, { useState, useEffect } from "react";
import "./Header.css";
import logo from "../../assets/trivia_logo.svg";
import '../../fonts.css';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 768px)");
        setIsOpen(mediaQuery.matches);

        const handleResize = (e) => setIsOpen(e.matches);
        mediaQuery.addEventListener('change', handleResize);
        return () => mediaQuery.removeEventListener('change', handleResize);
    }, []);

    const toggleNav = () => setIsOpen(!isOpen);

    const NAVIGATION_ITEMS = [
        { path: "/", label: "Home" },
        { path: "/checkscores", label: "Check Scores" },
        { path: "/about", label: "About" },
        { path: "/workwithus", label: "Book Us" },

    ];

    return (
        <header className="header">
            <div className="header_logo">
                <img src={logo} alt="Brain Brew Trivia Logo"/>
            </div>
            <div className="header_text">
                <h1 className="headerText1">Brain Brew Trivia</h1>
            </div>

            <div className="navigationContainer">
                <button className="burger" aria-label="Toggle navigation" onClick={toggleNav}>☰</button>
                <nav className={isOpen ? 'nav-open' : 'nav-closed'}>
                    <ul>
                        {NAVIGATION_ITEMS.map(({ path, label, external }) => (
                            <li key={path}>
                                <span className="arrow" />
                                <h3>
                                    <a
                                        href={path}
                                        {...(external && {
                                            target: "_blank",
                                            rel: "noreferrer"
                                        })}
                                    >
                                        {label}
                                    </a>
                                </h3>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;